import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteNotificationById } from './redux/dispatcher';

function SingleNotification({ data }) {
  const dispatch = useDispatch()
  const handleNotificationDelete = (id) => {
    dispatch(deleteNotificationById(id))
  }
  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '6px',
      padding: '15px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e9ecef',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    }} >
      <div style={{ flex: 1, paddingRight: '15px' }}>
        {data?.company_name && (
          <div style={{
            fontWeight: '600',
            marginBottom: '8px',
            color: 'rgb(14, 61, 13)',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <i className="fa-solid fa-building" style={{ fontSize: '12px' }}></i>
            {data.company_name}
            {" "}| Machine Number: {data.serial_number}
            {data?.created_at && (
              <span style={{
                fontWeight: '400',
                fontSize: '13px',
                color: '#6c757d',
              }}>
                | {new Date(data.created_at).toLocaleDateString()}, {new Date(data.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
          </div>
        )}
        <div style={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          color: '#495057',
          lineHeight: '1.5',
          fontSize: '14px'
        }}>
          {data?.message}
        </div>
        {(data?.specified_value || data?.observed_value || data?.serial_number) && (
          <div style={{
            marginTop: '8px',
            fontSize: '13px',
            color: '#6c757d',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px'
          }}>
            {data?.specified_value && <div><strong>Specified Value:</strong> {data.specified_value}</div>}
            {data?.observed_value && <div><strong>Observed Value:</strong> {data.observed_value}</div>}
          </div>
        )}
      </div>
      <div style={{
        cursor: 'pointer',
        padding: '5px',
        borderRadius: '5px',
        transition: 'background-color 0.2s'
      }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        onClick={() => handleNotificationDelete(data?.id)}>
        <i className="fa-solid fa-trash" style={{
          color: '#dc3545',
          fontSize: '16px',
          transition: 'color 0.2s'
        }}></i>
      </div>
    </div>
  );
}

export default SingleNotification;
